import React, { useEffect } from 'react';
import type { MarkAddressedModalProps } from './markAddressedModal';

/**
 * Holds the ignore checkbox state for the mark-addressed study modal. Keeps isIgnoreChecked in local state and clears it whenever the modal reopens while it is still ticked.
 *
 * @param isOpen - Whether the mark-addressed modal is currently open.
 * @returns The ignore checkbox value and its setter.
 */
export const useMarkAddressedModal = ({ isOpen }: Pick<MarkAddressedModalProps, 'isOpen'>) => {
  const [isIgnoreChecked, setIsIgnoreChecked] = React.useState(false);
  useEffect(() => {
    if (isOpen && isIgnoreChecked) {
      setIsIgnoreChecked(false);
    }
  }, [isOpen]);

  return { isIgnoreChecked, setIsIgnoreChecked };
};
